import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import MenuItems from "./MenuItems";

const drawerWidth = 256;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      marginTop: 60,
      height: 'calc(100vh - 60px)',
      overflowY: 'auto',
    },
  },
  drawerPaperMobile: {
    width: drawerWidth,
    height: '100vh',
    overflowY: 'auto',
  },
}));

const SideMenu = (props) => {
  const { mobileOpen, handleDrawerToggle, closeDrawer } = props;
  const classes = useStyles();
  const theme = useTheme();

  return (
    <React.Fragment>
      <Hidden smUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaperMobile,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <MenuItems closeDrawer={closeDrawer} variant="mobile" />
        </Drawer>
      </Hidden>

      <Hidden xsDown implementation="css">
        <CssBaseline />
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          <MenuItems closeDrawer={closeDrawer} variant="desktop" />
        </Drawer>
      </Hidden>
    </React.Fragment>
  );
};

export default SideMenu;
